/* eslint-disable prettier/prettier */
import React from 'react';
import _ from 'lodash';
import { Button, Image, Nav, Navbar, Col, Container, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import { AppNavigation, MessageNotification, ConnectedPatientSearch, UserMenu } from '.';
import { ResourceImage } from '.';
import { PatientRequestViewModelFragment } from '../graphql';
import logo from '../images/logo_CareMetx.png';
import { AnyType } from '../interfaces';
import { AppRootState, navigateToHome, logout, navigateToPatient } from '../redux';
import { FeatureGuard } from './multi-tenant/FeatureGuard';
import { CustomThemes } from '../utils/custom-themes';
import { ROUTE_PATHS, getConfigurationDataKey } from '../utils';

interface LeftNavbarProps {
  navigateToHome: () => void;
  navigateToPatient: (id: string | number) => void;
}

export const LeftNavbar = (props: LeftNavbarProps) => {
  const dispatch = useDispatch();
  const footerLinks = useSelector(
    (state: AppRootState) =>
      (((state.app.entities?.menus as AnyType) ?? {})[getConfigurationDataKey('navbar.footer')] as AnyType)?.data?.links
  );
  CustomThemes();
  return (
    <div className='parent-leftNavbar'>
      <Navbar collapseOnSelect expand='xl' className='text-uppercase cmx__hcp-nav1 align-items-center py-0'>
        <Navbar.Toggle aria-controls='responsive-navbar-nav' className='border-0' />
        <Navbar.Collapse className=''>
          <Nav className='flex-column w-90 text-capitalize'>
            <AppNavigation />
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <div className='footer-leftnavbar'>
        <div className='privacy-links'>
          {footerLinks?.map((link: AnyType, index: number) => (
            <Row className='text-center text-md-left termsofuse' key={index}>
              <a
                key={_.kebabCase(link.label)}
                href={(ROUTE_PATHS as AnyType)[link.url] || link.url}
                target='_blank'
                rel='noreferrer'
                className='pr-5 privacy'>
                {link.label}
              </a>
            </Row>
          ))}
        </div>

        <div className='logout-navbar' data-testid='cmx__logout' onClick={() => dispatch(logout())}>
          <i className='icon-logout fas fa-light fa-power-off'></i>
          <span className='logout-button'>Logout</span>
        </div>
      </div>
    </div>
  );
};

const renderPatientSearch = ({ navigateToPatient }: LeftNavbarProps) => {
  const patientSearchRef = React.createRef();

  const onPatientSelect = (patient: PatientRequestViewModelFragment) => {
    navigateToPatient(patient.patientId);
    (patientSearchRef.current as AnyType).clear();
  };

  return (
    <Form
      // Do nothing since the patient search handles state.
      // Form is needed since search is a final form field (used in other forms).
      onSubmit={() => undefined}
      render={() => (
        <div className='w-auto align-items-start'>
          <div className='cmx__patient-search'>
            <div className='cmx__patient-search__search-outlined-input'>
              <ConnectedPatientSearch
                asyncTypeaheadProps={{ ref: patientSearchRef }}
                placeholder='Patient Last Name or DOB'
                onPatientSelect={onPatientSelect}
                npiInfoSearch=''
              />
            </div>
          </div>
        </div>
      )}
    />
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  navigateToHome,
  navigateToPatient
};

export const ConnectedLeftNavToolbar = connect(mapStateToProps, mapDispatchToProps)(LeftNavbar);
